let serveUrl = ''

let domain = window.location.hostname
if (import.meta.env.MODE === 'production') { // 生产环境直接用用户输入的域名做请求
  if (domain === 'localhost') domain = import.meta.env.VITE_APP_DEMOSTIC_DOMAIN
  serveUrl = import.meta.env.VITE_APP_BASE_URL.replace('{domain}', domain)
} else {
  serveUrl = import.meta.env.VITE_APP_BASE_URL
}

export {
  serveUrl,
}
